import { FlexContainer, IconLibrary, ICON_MAP } from '@act/storybook';
import { Box, FormControlLabel, Switch, Typography } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { HospitalizationFormData } from '../types/hospitalizationFormData.types';

interface HospitalizationMetricItemProps {
  count: number;
  control?: Control<HospitalizationFormData>;
  metricName: string;
  iconName: keyof typeof ICON_MAP;
  fieldName?: 'notAttempted' | 'notOffered';
  flex?: number;
}

const HospitalizationMetricItem = ({
  control,
  count,
  metricName,
  iconName,
  fieldName,
  flex,
}: HospitalizationMetricItemProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        overflowY: 'hidden',
        gap: 2,
        padding: '16px 16px',
        height: 'auto',
        borderRadius: 'var(--border-radius-more-rounded)',
        backgroundColor: 'white',
        flex: flex || 1,
      }}
    >
      <FlexContainer
        direction="column"
        gap={1}
        alignItems="flex-start"
        overflow="visible"
      >
        <Typography component="p" variant="titleMedium">
          {metricName}
        </Typography>
        <Typography component="p" variant="headlineLarge">
          {count ?? '--'}
        </Typography>
        {control && fieldName && (
          <Controller
            name={fieldName}
            control={control}
            render={({ field: { onChange, value } }) => (
              <FormControlLabel
                labelPlacement="start"
                control={<Switch checked={value} onChange={onChange} />}
                label="Filter Members"
              />
            )}
          />
        )}
      </FlexContainer>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'flex-end',
          opacity: 0.8,
          position: 'relative',
          bottom: '-20px',
          right: -1,
        }}
      >
        <IconLibrary iconName={iconName} size={150} color="primary" />
      </Box>
    </Box>
  );
};

export default HospitalizationMetricItem;
